import React from 'react';
import { X, Archive, ArchiveRestore, Trash2 } from 'lucide-react';

const MultiSelectToolbar = ({
  isSelectMode,
  selectedChatIds,
  exitSelectMode,
  selectAllChats,
  deselectAllChats,
  showingArchived,
  bulkArchiveChats,
  bulkUnarchiveChats,
  bulkDeleteChats
}) => {
  if (!isSelectMode) return null;

  return (
    <div className="mb-4 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-800">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <button
            onClick={exitSelectMode}
            className="p-1 rounded-full hover:bg-blue-200 dark:hover:bg-blue-800 transition-colors"
          >
            <X size={16} className="text-blue-600 dark:text-blue-400" />
          </button>
          <span className="text-sm font-medium text-blue-700 dark:text-blue-300">
            {selectedChatIds.size} selected
          </span>
        </div>
        <div className="flex items-center gap-1">
          <button
            onClick={selectAllChats}
            className="text-xs px-2 py-1 text-blue-600 dark:text-blue-400 hover:bg-blue-200 dark:hover:bg-blue-800 rounded transition-colors"
          >
            All
          </button>
          <button
            onClick={deselectAllChats}
            className="text-xs px-2 py-1 text-blue-600 dark:text-blue-400 hover:bg-blue-200 dark:hover:bg-blue-800 rounded transition-colors"
          >
            None
          </button>
        </div>
      </div>
      
      {selectedChatIds.size > 0 && (
        <div className="flex gap-2">
          {showingArchived ? (
            <button
              onClick={bulkUnarchiveChats}
              className="flex items-center gap-1 px-3 py-1.5 bg-green-500 hover:bg-green-600 text-white text-xs rounded transition-colors"
            >
              <ArchiveRestore size={12} />
              Unarchive
            </button>
          ) : (
            <button
              onClick={bulkArchiveChats}
              className="flex items-center gap-1 px-3 py-1.5 bg-yellow-500 hover:bg-yellow-600 text-white text-xs rounded transition-colors"
            >
              <Archive size={12} />
              Archive
            </button>
          )}
          <button
            onClick={bulkDeleteChats}
            className="flex items-center gap-1 px-3 py-1.5 bg-red-500 hover:bg-red-600 text-white text-xs rounded transition-colors"
          >
            <Trash2 size={12} />
            Delete
          </button>
        </div>
      )}
    </div>
  );
};

export default MultiSelectToolbar;